export default {
  // 个人收集清单
  personalInfoChecklist: [],
  // 时间选择范围
  pickerSelectOptions: [
    {label: '最近七天', key: 'one_week'},
    {label: '最近一个月', key: 'one_month'},
    {label: '最近三个月', key: 'three_month'},
    {label: '最近一年', key: 'one_year'},
    {label: '历史所有', key: 'all'}
  ]
}